// Define the size options for the icon
export type IconSize = "small" | "medium" | "large" | "xlarge" | "xxlarge";

// Define the props for the Icon component
export type IconProps = {
  size?: IconSize; // small, medium, or large
  color?: string; // The color of the icon
  className?: string; // Additional Tailwind classes
  fontSize?: number; // Optional fontSize to override size
};

// Map size values to corresponding pixel sizes
export const sizeMap = {
  small: 16,
  medium: 24,
  large: 36,
  xlarge: 48,
  xxlarge: 64,
};

// Default props for the Icon component
export const defaultIconProps: IconProps = {
  size: "medium", // Default to medium size
  color: "currentColor",
};
